import React from 'react';
import { useSelector } from 'react-redux';
import { TitleText, About } from './styled';

interface Props {
  children: React.ReactNode;
  className?: string;
  description?: string;
  color?: string;
}

export const Title: React.FC<Props> = ({
  children,
  className,
  description,
  color
}) => {
  const operations = useSelector(state => state.typeOperation.data);

  return (
    <React.Fragment>
      <TitleText className={className} color={color}>{children}</TitleText>
      {
        description && operations && operations.length > 0 && <About>{description}</About>
      }
    </React.Fragment>
  )
};
